(function () {
  'use strict';

  function injectSaveBadge() {
    document.querySelectorAll('.gr-save-badge').forEach(function(n){ n.remove(); });

    var productInfo = document.querySelector('.product-information, [class*="product-details"], [data-section-type="product-information"]');
    if (!productInfo) return false;

    var saleEl    = productInfo.querySelector('.price-item--sale');
    var compareEl = productInfo.querySelector('.price-item--regular, .compare-at-price, s.price-item');

    if (!saleEl || !compareEl) return false;

    var sale    = parseFloat(saleEl.textContent.replace(/[^0-9.]/g, ''));
    var compare = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));

    if (!sale || !compare || compare <= sale) return false;

    var pct = Math.round((1 - sale / compare) * 100);
    if (pct < 1 || pct > 99) return false;

    var badge = document.createElement('span');
    badge.className = 'gr-save-badge';
    badge.textContent = 'SAVE ' + pct + '%';

    compareEl.parentNode.insertBefore(badge, compareEl.nextSibling);
    return true;
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  function init() {
    if (!document.querySelector('.product-information, [class*="product"]')) return;

    /* Initial badge with capped retries */
    var attempts = 0;
    var maxAttempts = 10;
    function tryBadge() {
      var ok = injectSaveBadge();
      if (!ok && attempts < maxAttempts) {
        attempts++;
        setTimeout(tryBadge, 400);
      }
    }
    tryBadge();

    /* INP fix: longer debounce + auto-disconnect after page settles */
    var root = document.querySelector('.product-information') || document.body;
    var mutationCount = 0;
    var MAX_MUTATIONS = 30;
    var debouncedBadge = debounce(function() {
      injectSaveBadge();
    }, 800);

    var mo = new MutationObserver(function(mutations) {
      mutationCount += mutations.length;
      if (mutationCount > MAX_MUTATIONS) {
        mo.disconnect();
        return;
      }
      var relevant = mutations.some(function(m) {
        return Array.from(m.addedNodes).every(function(n) {
          return !n.classList || !n.classList.contains('gr-save-badge');
        });
      });
      if (relevant) debouncedBadge();
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }
  document.addEventListener('shopify:section:load', init);

})();

/* ALERT (Guam Route accessibility fix 10-20-26):
   1) Links/buttons inside carousel slides that are hidden from screen readers (aria-hidden="true") are taken out of
      the keyboard tab order, and put back when the slide becomes visible.
   2) Footer logo link gets a readable name ("Guam Route home").
   Revert = remove this block. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function syncSlide(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll(FOCUSABLE + ', [data-gr-tab-hidden]').forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-gr-tab-hidden')) {
          el.setAttribute('data-gr-tab-hidden', el.getAttribute('tabindex') || '');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-gr-tab-hidden')) {
        var prev = el.getAttribute('data-gr-tab-hidden');
        if (prev) { el.setAttribute('tabindex', prev); } else { el.removeAttribute('tabindex'); }
        el.removeAttribute('data-gr-tab-hidden');
      }
    });
  }

  function run() {
    document.querySelectorAll('slideshow-slide, [aria-hidden="true"]').forEach(function (el) {
      if (el.tagName === 'SLIDESHOW-SLIDE' || el.querySelector(FOCUSABLE)) syncSlide(el);
    });

    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && m.target.nodeType === 1) syncSlide(m.target);
      });
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });

    document.querySelectorAll('footer a.image-block, footer [class*="image-block"] a, footer a[class*="image-block"]').forEach(function (a) {
      if (!a.getAttribute('aria-label') && !a.textContent.trim()) {
        var img = a.querySelector('img');
        if (!img || !img.getAttribute('alt')) a.setAttribute('aria-label', 'Guam Route home');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
